import axios, { AxiosRequestConfig } from 'axios';
import { DataResponse, PagedResponse } from '../types/api';
import { SavedSearch } from '../types/SavedSearch';
import { SitterSearchCloseReason } from '../types/SitterSearchCloseReason';

const URL = '/v2/sitter-searches';
const CLOSE_REASONS_URL = '/v2/sitter-search-close-reasons';

class SavedSearchService {
  static getByFilter(params: string, config?: AxiosRequestConfig): Promise<PagedResponse<SavedSearch>> {
    return axios.get(`${URL}${params}`, config);
  }

  static getSavedSearchByFilter(config?: AxiosRequestConfig): Promise<PagedResponse<SavedSearch>> {
    return axios.get(URL, config);
  }

  static getById(id: number, config?: AxiosRequestConfig): Promise<DataResponse<SavedSearch>> {
    return axios.get(`${URL}/${id}`, config);
  }

  static getCloseReasons(config?: AxiosRequestConfig): Promise<PagedResponse<SitterSearchCloseReason>> {
    return axios.get(CLOSE_REASONS_URL, config);
  }

  static saveSearch(data: SavedSearch, config?: AxiosRequestConfig): Promise<DataResponse<SavedSearch>> {
    return axios.post(URL, data, config);
  }

  static updateSearch(id: number, data: SavedSearch, config?: AxiosRequestConfig): Promise<DataResponse<SavedSearch>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }

  static delete(id: number, config?: AxiosRequestConfig): Promise<unknown> {
    return axios.delete(`${URL}/${id}`, config);
  }

  static patch(id: number, data: unknown, config?: AxiosRequestConfig): Promise<DataResponse<SavedSearch>> {
    return axios.patch(`${URL}/${id}`, data, config);
  }
}

export { SavedSearchService };
